import { createSlice } from '@reduxjs/toolkit';

interface GlobalState {
  user: Record<string, unknown> | null;
  isAuthenticated: boolean;
  featureFlags: Record<string, boolean>;
}

const initialState: GlobalState = {
  user: null,
  isAuthenticated: false,
  featureFlags: {},
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
    setFeatureFlag: (state, action) => {
      state.featureFlags[action.payload.name] = action.payload.enabled;
    },
  },
});

export const { setUser, clearUser, setFeatureFlag } = globalSlice.actions;
export default globalSlice.reducer;
